import React, { useState, useEffect } from "react";
import { isMobile } from "react-device-detect";

const DurationDropDownMenu = (props) => {
  let periodDurationValue = !isNaN(props.periodDuration)
    ? props.periodDuration
    : props.periodDurationDefaults != null
    ? props.periodDurationDefaults.averagePeriodDurationDefault
    : 3;

  const [periodDuration, setPeriodDuration] = useState("");
  const [min, setMin] = useState(
    props.periodDurationDefaults.minimumPeriodDuration
  );
  const [max, setMax] = useState(
    props.periodDurationDefaults.maximumPeriodDuration
  );

  useEffect(() => {
    if (isMobile) {
      props.setenablecaloutsideclick(true);
    }
    setPeriodDuration(periodDurationValue);
    props.setPeriodDuration(periodDurationValue);
  }, []);

  const [disableMin, setDisableMin] = useState(false);
  const [disableMax, setDisableMax] = useState(false);

  useEffect(() => {
    if (periodDuration === max) {
      setDisableMax(true);
    } else if (periodDuration === min) {
      setDisableMin(true);
    }
  });

  const handleIncrement = () => {
    if (periodDuration < max) {
      setPeriodDuration((prev) => prev + 1);
      props.setPeriodDuration(periodDuration + 1);
    }
    if (periodDuration === max - 1) {
      setDisableMax(true);
    } else {
      setDisableMin(false);
      setDisableMax(false);
    }
  };

  const handleDecrement = () => {
    if (periodDuration > min) {
      setPeriodDuration((prev) => prev - 1);
      props.setPeriodDuration(periodDuration - 1);
    }
    if (periodDuration === min + 1) {
      setDisableMin(true);
    } else {
      setDisableMin(false);
      setDisableMax(false);
    }
  };

  return (
    <>
      {!isMobile && (
        <div className="duration-popup" id="duration-dropdown">
          <button
            className="popupcircle minus"
            onClick={handleDecrement}
            disabled={disableMin}
          ></button>
          <input
            id="numberInput"
            type="text"
            min="0"
            max="100"
            value={periodDuration}
            className="number-input"
          />
          <button
            className="popupcircle plus"
            onClick={handleIncrement}
            disabled={disableMax}
          ></button>
        </div>
      )}
      {isMobile && (
        <>
          <div className="duration-popup-sm">
            <div className="row text-center">
              <div className="col-12 mt-4">
                <span>Number of Days</span>
              </div>
              <div className="col-12">
                <div className="d-flex align-items-center justify-content-center">
                  <button
                    className="popupcircle minus"
                    onClick={handleDecrement}
                    disabled={disableMin}
                  ></button>
                  <input
                    id="numberInput"
                    type="text"
                    min="0"
                    max="100"
                    value={periodDuration}
                    className="number-input"
                  />
                  <button
                    className="popupcircle plus"
                    onClick={handleIncrement}
                    disabled={disableMax}
                  ></button>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default DurationDropDownMenu;
